// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sbps-container {
    display: flex;
    justify-content: center;
}

.skitterbook-live-print-button-container > * {
    width: fit-content;
    align-self: center;
}
`, "",{"version":3,"sources":["webpack://./src/Skitterbook/css/SkitterBookPaperSize.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB","sourcesContent":["@import '../../css/App.css';\r\n\r\n.sbps-container {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.skitterbook-live-print-button-container > * {\r\n    width: fit-content;\r\n    align-self: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
